import Gen from '@helper/Gen';
import BOGen from './helper/BOGen';

var bo_router = [
  {path: "dashboard", name: "BoDashboard", component:()=> import("@backend/Dashboard.vue")},
  {path: "profile", name: "BoProfile", component:()=> import("@backend/Profile.vue")},
  
  //Budgeting
  {path: "trx-budgeting/:id?", name: "BoTrxBudgeting", component:()=> import("@backend/TrxBudgeting.vue")},

  //Production
  {path: "client/:id?", name: "BoTrxClient", component:()=> import("@backend/TrxClient.vue")},
  {path: "project/:id?", name: "BoTrxProject", component:()=> import("@backend/TrxProject.vue")},
  {path: "document/:id?", name: "BoTrxDocument", component:()=> import("@backend/TrxDocument.vue")},

  //Master Settings
  {path: "doc-access-type/:id?", name: "BoDocAccessType", component:()=> import("@backend/DocAccessType.vue")},
  {path: "doc-department/:id?", name: "BoDocDepartment", component:()=> import("@backend/DocDepartment.vue")},
  {path: "doc-type/:id?", name: "BoDocType", component:()=> import("@backend/DocType.vue")},
  {path: "doc-product-type/:id?", name: "BoDocProductType", component:()=> import("@backend/DocProductType.vue")},
  {path: "budget-cash-type/:id?", name: "BoBudgetCashType", component:()=> import("@backend/BudgetCashType.vue")},
  {path: "budget-type/:id?", name: "BoBudgetType", component:()=> import("@backend/BudgetType.vue")},
  {path: "budget-category/:id?", name: "BoBudgetCategory", component:()=> import("@backend/BudgetCategory.vue")},
  
  // User Management
  {path: "users/:id?", name: "BoUsers", component:()=> import("@backend/Users.vue")},
  {path: "user-level/:id?", name: "BoUserLevel", component:()=> import("@backend/UserLevel.vue")},
  // 404
  {path: '*', redirect: {name:"BoDashboard"}},
];

var menuBypassRole = ["BoProfile"]

bo_router.map((v)=>{
  v.beforeEnter = (to, from, next)=>{
    var user = BOGen.user()
    if(!user || !Gen.getStorage('botk')) return next({name:"BoLogin"})
    if(menuBypassRole.indexOf(to.name)>-1) return next()
    if(user.bu_level==0) return next()
    if(user.menuRole.indexOf(to.name) == -1) return next({name:user.menuRole[0]})
    next()
  }
  v.meta = {bo_protected:true}
})

var data = [
  {
    name: "BoLogin",
    path: "/",
    component: () => import("@backend/Login.vue"),
    beforeEnter: (to, from, next)=>{
      var user = BOGen.user()
      if(user && Gen.getStorage('botk')) return next({name:"BoDashboard"})
      next()
    }
  },
  // FileManager
  {
    name: "FileManager",
    path: 'file-explore',
    component:()=> import("@components/FileManagerPage.vue")
  },
  {
    path:"",
    component: () => import('@/layout/BoLayout.vue'),
    redirect: {name:'BoDashboard'},
    children: bo_router
  },
]

export default data